import { UseFormReturn } from 'react-hook-form';
import { FormattedMessage, useIntl } from 'react-intl';

import SelectFormField from 'src/registry/components/forms/SelectFormField';
import { Form, FormControl, FormControlStack, FormField, FormItem, FormLabel, FormMessage } from 'src/registry/ui/Form';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from 'src/registry/ui/Select';
import { ExitFromParkingFormSchemaValues } from 'src/features/stay/utils/formSchema';
import { useListGateways } from 'src/features/gateway/api/useListGateways';
import { useParking } from 'src/providers/ParkingProvider';
import { visitorMessages } from 'src/features/visitor/utils/messages';
import { BOOLEAN_MAP, BOOLEAN_OPTIONS } from 'src/features/sites/utils/constants';

type ExitFromParkingFormProps = {
    form: UseFormReturn<ExitFromParkingFormSchemaValues>;
    onSubmit: (values: ExitFromParkingFormSchemaValues) => void;
};

const ExitFromParkingForm = ({ onSubmit, form }: ExitFromParkingFormProps) => {
    const { formatMessage, locale } = useIntl();
    const { parkingId } = useParking();

    const { data: exitGateways } = useListGateways({
        is_exit: true,
        parkingId,
    });

    return (
        <Form form={form} onSubmit={form.handleSubmit(onSubmit)} variant="dialog">
            <FormField
                control={form.control}
                name="exit_gateway"
                render={({ field }) => (
                    <FormItem variant="dialog">
                        <FormLabel variant="dialog" required>
                            <FormattedMessage {...visitorMessages.exitGateway} />
                        </FormLabel>
                        <FormControlStack>
                            <FormControl>
                                <Select onValueChange={field.onChange} value={field.value}>
                                    <SelectTrigger className="w-full">
                                        <SelectValue placeholder={`${formatMessage(visitorMessages.exitGateway)}...`} />
                                    </SelectTrigger>
                                    <SelectContent>
                                        {exitGateways?.results.map((option) => (
                                            <SelectItem key={option.id} value={option.id}>
                                                {
                                                    option.translations.find(
                                                        (translation) => translation.language === locale,
                                                    )?.name
                                                }
                                            </SelectItem>
                                        ))}
                                    </SelectContent>
                                </Select>
                            </FormControl>
                            <FormMessage />
                        </FormControlStack>
                    </FormItem>
                )}
            />
            <SelectFormField<ExitFromParkingFormSchemaValues>
                form={form}
                required
                isBoolean
                name="open_gateway"
                label={formatMessage(visitorMessages.openGateway)}
                options={Object.values(BOOLEAN_OPTIONS)}
                optionTranslationMap={BOOLEAN_MAP}
            />
        </Form>
    );
};

export default ExitFromParkingForm;
